function ChangeSummary() {
/// <summary>
    /// This object provides the menu handling for the VC.Widget.Admin.ChangeSummary.vb.<br/>
    /// Depending on the clicked menu item it loads various visuals. 
    /// Author: AFU<br />
    /// Date: 12.10.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 12.10.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -  basic functionality                                             *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.frameHeight = 0;
    this.frameWidth = 0;
}

ChangeSummary.prototype = new vcTemplate();

ChangeSummary.prototype.init = function () {
    /// <summary>
    /// This function sets specific widths, heights and inits the specific event handlers.<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }

        me.frameHeight = parseInt(me.height - me.visual.find("#divMenu").height(), 10) - 2;
        me.frameWidth = parseInt(me.width - 2);
        me.visual.find("#divFrame").height(me.frameHeight);
        me.frameHeight -= 10;

        me.showInfo("", "", false);
        me.toggleMenu(me.visual.find(".button-toggle-active"));
        me.visual.find("#divMenu .button-toggle").off("click").on("click", function() {me.toggleMenu($(this))}).button();
       

      
        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}


ChangeSummary.prototype.toggleMenu = function (obj) {
    /// <summary>
    /// This function handles the opening of the clicked menu items<br/>
    /// </summary>
    var me = this;
    var param;
    var random;
    try {
        if (me.error) {
            return false;
        }
       
        me.visual.find("#divMenu .button-toggle").removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");

        //get a random vcgid
        random = parseInt(Math.random()*100000,10);
        //fill a new div with the random id into the frame 
        var detail = $("<div>").attr("id", "divFrameDetail" + random).height(me.frameHeight).width(me.frameWidth).html(me.vcC.getLoadingIcon());
        me.visual.find("#divFrame").html(detail);
        
        switch (obj.data("type")) {
            case "HISTORY":
                param = { "ShowAllMyProjects":true };
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_UNIT_HISTORY", random, getCurrentTimestamp(), me.frameHeight, me.frameWidth, JSON.stringify(param), "", me.deviceType);
                break;
            
            case "INTERVENTION":
                param = { "ShowAllMyProjects": true, "Interval": 3 };
                me.vcVisual.addVisualByName('divFrameDetail', "VISUAL_INTERVENTION_LIST", random, getCurrentTimestamp(), me.frameHeight, me.frameWidth, JSON.stringify(param), "", me.deviceType);
                break;
            case "ACTIVITY":
                me.vcVisual.addVisualByName('divFrameDetail', "WIDGET_ACTIVITY", random, getCurrentTimestamp(), me.frameHeight, me.frameWidth, "23:59,bdid,false,3,10", "true", me.deviceType);
                break;
            //case "LOGIN":
            //    param = { "bsaid": me.bsaid };
            //    me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_SIGNAL_ANALOG_OVERVIEW", random, getCurrentTimestamp(), me.frameHeight, me.frameWidth, JSON.stringify(param), "", me.deviceType);
            //    break;

            default:
        }
        return true;
    } catch (ex) { me.writeError('initClickHandler', ex); return false }
};

ChangeSummary.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
             me.visual.find('#divFrame').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};



